import { createPinia, setActivePinia } from 'pinia';
import { socketIoInstance } from '@/vuex/plugins/websocket.util';
import { analyticsPlugin } from './plugins/analytics.plugin';
import { sessionPlugin } from './plugins/session.plugin';
import { createSocketIoPlugin } from './plugins/socket-io.plugin';

export const pinia = createPinia();
// Required before vueApp.use(pinia): auth/init dispatches before initVueApp() runs,
// and Vuex modules (auth, domains, emails, themes, layouts) call useOrganizationStore()
// at action-invocation time. Without this, those calls throw "No active Pinia".
setActivePinia(pinia);

pinia.use(analyticsPlugin);
pinia.use(sessionPlugin);
pinia.use(createSocketIoPlugin(socketIoInstance));

export * from './themes.store';

export * from './layouts.store';

export { useDashboardsStore } from './dashboards.store';

export { useSavedViewsStore } from './saved-views.store';
